module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_3.7190fdf5.png";